/* eslint-disable jsx-a11y/href-no-hash */
import React from "react";
import styles from "./styles.css";
import { Segment, Container } from "semantic-ui-react";

export class TOSEN extends React.Component {
  state = {};

  render() {
    return (
      <Segment style={{ padding: "4em 0em", margin: 0 }}>
        <Container text>
          <div className={styles.registerForm} style={{ fontSize: "1.33em" }}>
            <div>
              <h1>Terms of use</h1>
              <h2>§1 Scope of application</h2>
              <p>
                (1) The following conditions apply to the use of the services
                of Audory.io - hereinafter referred to as "Audory". It is
                important for the use of the platform that you as a user accept
                the following rules and conditions. Registration and use of our
                platform is free of charge.
                <br />
                <br />
                (2) By registering, you agree to the terms of use of Audory.
                By giving us your consent, you guarantee that you will not
                create any stories or comments that violate the terms of use.
                <br />
                <br />
                (3) The use of Audory does not constitute a contract between
                the users and us.
              </p>
              <h2>§2 Obligations as a user</h2>
              <p>
                (1) One of your duties as a user is not to publish any contributions
                that violate these rules, morality or any other applicable German law.
                <br />
                <br />
                <u>The following points are not permitted:</u>
                <ol>
                  <li>
                    Publish content that is untrue and whose publication constitutes
                    a criminal offence or a misdemeanour.
                  </li>
                  <li>
                    Sending spam via comments to other users.
                  </li>
                  <li>
                  Use of content protected by copyright and trademark law without
                  legitimate authorization (e.g. background music, sound effects,
                  protected characters, etc.).
                  </li>
                  <li>Actions that are anti-competitive.</li>
                  <li>
                    Multiple posting of stories or contributions (so-called double postings).
                  </li>
                  <li>
                    Publish content that is offensive, racist, discriminatory or
                    pornographic towards other users and the general public.
                  </li>
                </ol>
                It is your duty as a user to observe § 2 para. 1 no. 1-6 of these terms of
                use before publishing your contribution on the platform and to check whether
                you have adhered to these points.
                <br />
                <br />
                (2) Should you violate § 2 Abs. 1 Nr. 1-7 of these terms of use, we reserve
                the right to take the following steps against you:
                <ol>
                  <li>
                    Delete or modify your posts.
                  </li>
                  <li>
                    Prohibition to continue to write contributions on the platform.
                  </li>
                  <li>Blocking of access as user.</li>
                </ol>
                (3) If you as the user of the platform have not observed the rules
                and if this has resulted in possible violations of the law which
                have arisen as a result of your content posted on our platform
                (breach of duty), you as the user undertake to indemnify us against
                any claims, including claims for damages, and to reimburse these costs.
                <br />
                <br />
                In addition, the user is obliged to inform us in the case of
                claims for damages with regard to the defence against the damage caused by him.
                the breach of law (breach of duty, see above), to the exclusion of
                and to support the costs of an adequate
                legal defense for us to bear.
                <br />
                <br />
                (4) By giving us your consent, you guarantee us that you will not
                create content that violate our terms and conditions.
                The same applies to the setting of external
                Links in descriptions and comments.
              </p>
              <h2>§3 Transfer of rights of use</h2>
              <p>
                You, the user, have the sole responsibility of copyright in the sense
                of the copyright law when publishing stories and comments on the platform
                to observe. As a user, you merely grant us the right to make the contribution
                permanently available for retrieval by publishing your story or commentary
                on Audory. Furthermore, our team has the right to delete, edit and move your
                story and contributions within the platform in order to link them with other
                content (e.g. category pages of the stories).
                <br />
                <br />
                You can request at any time to have all content provided by you deleted
                by the platform.
              </p>
              <h2>§4 Limitation of liability</h2>
              <p>
                (1) We do not assume any liability for the stories, comments, external links 
                and the resulting contents published and posted on the platform, in particular
                not for their correctness, completeness and topicality. We are also not obliged
                to permanently monitor the transmitted and stored contributions of the users or
                to investigate whether they refer to illegal content according to the circumstances.
                In principle, we are only liable in the event of an intentional or grossly
                negligent breach of duty.
                <br />
                <br />
                (2) We assume no liability for the content and correctness of advertisements
                placed by users within comments or stories. The respective author is solely
                responsible for the content of the advertisements; the same applies to the
                content of the advertised item. With representation of the advertisement on
                our web page, we do not agree at the same time with illegal contents.
                Therefore the liability lies exclusively with the respective author.
                <br />
                <br />
                (3) It is not guaranteed that the platform will be constantly accessed
                without interruption. Any liability in this respect is hereby expressly
                rejected. Even with great care, downtimes can unfortunately not be
                excluded. Planned maintenance work will be indicated in good time (5 days in advance).
              </p>
              <h2>§5 Copyright</h2>
              <p>
                All texts, images and other information and data published on our
                platform are subject to the copyright of Audory or the respective author
                unless otherwise indicated. Any form of reproduction and/or modification
                may only take place with the written permission of us or the authors.
                Otherwise, we reserve the right to take legal action against this
                infringement. All costs, which are caused by a law breaking on the
                part of a user, are charged to this.
              </p>
              <h2>§6 Subject to change</h2>
              <p>
                We have the right to change the terms of use at any time.
                The change will then be announced to all users on the platform.
              </p>
              <h2>§7 Cancellation and term of membership at Audory</h2>
              <p>
                The term of the membership begins with the registration and with
                the agreement of our terms of use and exists for an indefinite period.
                The membership can be terminated at any time without notice without
                giving notice. The membership at Audory is free of charge.
              </p>
              <h2>§8 Severability clause</h2>
              <p>
                These terms of use are to be regarded as part of Audory, from which
                reference is made to this page. If individual formulations of these
                terms of use are no longer fully or no longer fully compliant with
                the applicable legal situation, it is to be assumed that the remaining
                provisions of the terms of use remain in force.
              </p>
            </div>
          </div>
        </Container>
      </Segment>
    );
  }
}

export default TOSEN;



// WEBPACK FOOTER //
// ./src/components/TOS/TOSEN.js